import Component from 'vue-class-component';
import { Mixins, Provide, Watch } from 'vue-property-decorator';
import EdPresentationModeFactory from '@/content/factories/ed-presentation-mode.factory';
import WebSocketMessageResponse from '@/content/models/web-socket-message-response.model';
import WebSocketMessageRequest from '@/content/models/web-socket-message-request.model';
import { FORWARD_PRESENTATION_MESSAGES_EVENT, _APP_STORE } from '@/core/values/app.values';
import * as PRESENTATION_VALUES from '@/content/values/ed-presentation-mode.values';
import { AUTH_STORE } from '@/auth/store/auth.store';
import { MEETINGS_STORE } from '@/meetings/store/meetings.store';
import PresentationModeViewerMixin from '@/content/mixins/ed-presentation-mode-viewer.mixin';
import { COURSE_EVENTS } from '@/content/values/events';
import { EdJitsiMixin } from '@/components/screen-share/ed-screen-share/ed-jitsi-mixin'

@Component({})
export default class EdPresentationModeStudent extends Mixins(PresentationModeViewerMixin, EdJitsiMixin) {

  @Provide()
  messageEvent = new Map();

  private pendingMessages: any = {};

  get presentationModeMeetings(): number[] {
    return this.$store.state.MeetingsStore.presentationModeMeetings;
  }

  get existsMeeting(): boolean {
    return this.presentationModeMeetings.includes(this.roomId);
  }

  get isWebView(): boolean {
    return this.$store.state.AppStore.webview;
  }

  /**
   * @override
   * @param data
   * @returns
   */
  public async loadInitialDocument(data: WebSocketMessageResponse): Promise<void> {
    this.isObtainInitialCourse = false;
    if (data.error) {
      this.showErrorMessage();
      return;
    }

    if(this.isInitialLoaded){
      return;
    }

    if(!(data && data.messages && Object.keys(data.messages).length > 0)){
      setTimeout(() => this.obtainInitialCourse(), 1000);
      return;
    }

    this.isInitialLoaded = true;
    this.messageHigher = null;

    for (let key in data.messages) {
      if (!this.messageHigher || data.messages[key].time > this.messageHigher.time) {
        this.messageHigher = data.messages[key];
      }
    }

    this.validateBasicMessages();
    this.$store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_INITIAL_PRESENTATION_MODE_MESSAGE, this.messageHigher);
  }

  /**
  * @override
  */
  public validateConnection(): void {
    if (this.existsMeeting && !this.isLoading) {
      this.$EdToast.hide();
    }

    if (this.isLoading && this.existsMeeting) {
      this.validateObtainInitialValues();
      this.showMessageNotDocument();
    }
  }

  private obtainInitialCourse(): void {
    if (this.isObtainInitialCourse) {
      return;
    }
    this.isObtainInitialCourse = true;
    let message: WebSocketMessageRequest = EdPresentationModeFactory.createWebSocketMessageRequest(PRESENTATION_VALUES.EVENT_TYPES.all, String(this.roomId));
    this.$EdSocket.emit(PRESENTATION_VALUES.SOCKET_EVENTS.connect, message);
    this.validateMeetingStatus();
  }

  private validateMeetingStatus(): void {
    if (this.existsMeeting && this.sectionMaterial === null && this.internalSection === null) {
      this.showMessageNotDocument();
    } else if (!this.existsMeeting) {
      this.leaveTeacherPresentation();
    }
  }

  private async processMessage(message: WebSocketMessageResponse): Promise<boolean> {
    if (!this.isInitialResize) {
      return;
    }
    if( this.isRemoteSharingScreen ) {
      return;
    }
    if (message && message.messageType && this.processors[message.messageType] && message.topicId === this.roomId) {
      let data = JSON.parse(message.content);
      this.messageEvent.set(message.messageType, message.content);
      return await this.processors[message.messageType](data, true);
    }
  }


  private async leaveTeacherPresentation(): Promise<void> {
    if (!this.existsMeeting) {
      this.genericLeaveTeacherPresentation();
    }
  }


  private validateParamsToInit(): void {
    if (this.$store.state.AppStore.presentationSocketConnected && this.$store.state.AuthStore.user.userId) {
      this.obtainInitialCourse();
    }
  }

  private validateStoreValues() {
    this.$store.subscribe((mutation) => {
      if (mutation.type === _APP_STORE.MUTATIONS.SET_PRESENTATION_SOCKET_CONNECTED || mutation.type === AUTH_STORE.MUTATIONS.SET_USER_INFO) {
        this.validateParamsToInit();
      }
    });
  }

  private validateObtainInitialValues() {
    if (this.$store.state.AppStore.presentationSocketConnected && this.$store.state.AuthStore.user.userId) {
      this.obtainInitialCourse();
    } else {
      this.validateStoreValues();
    }
  }

  private async forwardMessages(): Promise <void> {
    if (!this.existsMeeting) {
      this.leaveTeacherPresentation();
      return;
    }
    await this.restoreDefaultValues();
    this.validateConnection();
  }

  private async sendTextChanged(data: any): Promise<void> {
    await this.sendMessage(PRESENTATION_VALUES.EVENT_TYPES.text, data, false);
  }

  private sendMessage(messageType: string, data: any, onlySave: boolean = false): Promise<void> {
    return new Promise(resolve => {
      if (!this.$store.state.AppStore.presentationSocketConnected || !this.isPresentationNavigation ) {
        this.pendingMessages[messageType] = { data, onlySave };
        resolve();
        return;
      }

      delete this.pendingMessages[messageType];
      let message: WebSocketMessageRequest = EdPresentationModeFactory.createWebSocketMessageRequest(messageType, String(this.roomId), onlySave, JSON.stringify(data));
      this.$EdSocket.emit(PRESENTATION_VALUES.SOCKET_EVENTS.events, message, () => resolve());
    });
  }

  @Watch('isRemoteSharingScreen')
  private onRemoteUserIsSharingScreen() {
    if( this.isRemoteSharingScreen ) {
      this.$EdToast.hide();
    } else {
      //when stops sreen sharing then refresh meeting status
      this.forwardMessages();
    }
  }

  mounted() {
    this.validateMeetingStatus();
    this.$edEventBus.$on(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.RESPONSE_EVENT, this.processMessage);
    this.$edEventBus.$on(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.LEAVE_TEACHER_EVENT, this.leaveTeacherPresentation);
    this.$edEventBus.$on(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.SUSCRIBE_TEACHER_EVENT, this.validateConnection);
    this.$edEventBus.$on(FORWARD_PRESENTATION_MESSAGES_EVENT, this.forwardMessages);
    this.$edEventBus.$on(COURSE_EVENTS.SEND_TEXT_CHANGED, this.sendTextChanged);
  }

  beforeDestroy() {
    this._unload();
    this.$edEventBus.$off(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.RESPONSE_EVENT, this.processMessage);
    this.$edEventBus.$off(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.LEAVE_TEACHER_EVENT, this.leaveTeacherPresentation);
    this.$edEventBus.$off(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.SUSCRIBE_TEACHER_EVENT, this.validateConnection);
    this.$edEventBus.$off(FORWARD_PRESENTATION_MESSAGES_EVENT, this.forwardMessages);
    this.$edEventBus.$off(COURSE_EVENTS.SEND_TEXT_CHANGED, this.sendTextChanged);
  }
}
